import { motion } from "framer-motion";

export const ServicesIntro = () => (
  <div className="max-w-6xl mx-auto px-5 sm:px-8 pt-20 sm:pt-28" data-testid="services-intro">
    <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.75, ease: [0.16, 1, 0.3, 1] }}>
      <p className="font-mono-ui text-[11px] uppercase tracking-[0.3em] text-cyan-300 mb-4">Chaque univers a sa couleur, sa lumière</p>
      <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-none">9 univers, <span className="text-outline">un seul numéro</span></h2>
      <p className="mt-4 max-w-2xl text-slate-300 text-base sm:text-lg leading-relaxed">Choisis ton univers, clique, demande : devis gratuit, croquis offert, et une réponse rapide — à domicile ou à l'atelier.</p>
    </motion.div>
  </div>
);